import {useState} from 'react';
import Button from "patient-ping-remedy/packages/button";
import Popover from "patient-ping-remedy/packages/popover";
import CreateButtonContent from "@/components/header/CreateButtonContent";
import CreateAdmission from "@manual_encounters/CreateAdmission";
import CreateReferralSso from "@clients/referral/CreateReferralSso";
import Icon from "patient-ping-remedy/packages/icon";
import {colors} from "patient-ping-remedy/packages/theme";
import CreateReferrals from "@/components/pages/referrals/CreateReferrals";

const CreateButton = () => {
  const [showPopover, setShowPopover] = useState(false);
  const [showAdmissionModal, setShowAdmissionModal] = useState(false);
  const [showReferralSsoModal, setShowReferralSsoModal] = useState(false);
  const [showReferralModal, setShowReferralModal] = useState(false);

  return (
    <>
      <Popover
        toggle={() => setShowPopover(!showPopover)}
        isOpen={showPopover}
        content={(
          <CreateButtonContent
            hidePopover={() => setShowPopover(false)}
            showAdmissionModal={() => setShowAdmissionModal(true)}
            showReferralSsoModal={() => setShowReferralSsoModal(true)}
            showReferralModal={() => setShowReferralModal(true)}
          />
        )}
        position={"bottom-start"}
        triggerTestId={"create-admission-popover"}
      >
        <Button onClick={() => setShowPopover(!showPopover)}>
          <Icon iconClass={'plus'} color={colors.white} style={{ marginRight: '10px' }} />
          Create
        </Button>
      </Popover>
      {showAdmissionModal && <CreateAdmission hideModal={() => setShowAdmissionModal(false)} />}
      {showReferralSsoModal && <CreateReferralSso hideModal={() => setShowReferralSsoModal(false)} />}
      {showReferralModal && <CreateReferrals hideModal={() => setShowReferralModal(false)}/>}
    </>
  );
};

export default CreateButton;
